(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["box-composer"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.box-composer').forEach(function (wrapper) {
      if (wrapper.dataset.boxComposerInit) return;
      wrapper.dataset.boxComposerInit = 'true';

      var max = parseInt(wrapper.dataset.maxSelect, 10);
      var cards = wrapper.querySelectorAll('.box-composer__card');
      var counter = wrapper.querySelector('.box-composer__count-value');
      var progressBar = wrapper.querySelector('.box-composer__progress-bar');
      var errorMsg = wrapper.querySelector('.box-composer__error');

      // Le bloc n'est pas forcément imbriqué dans le <form> du produit
      // (architecture Horizon) : on cherche donc plus largement.
      var section = wrapper.closest('.shopify-section') || document;
      var form =
        wrapper.closest('form[action*="/cart/add"]') ||
        section.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');

      function selectedCards() {
        return Array.prototype.filter.call(cards, function (c) { return c.classList.contains('is-selected'); });
      }

      function updateState() {
        var selected = selectedCards();
        counter.textContent = selected.length;
        if (progressBar) {
          var pct = Math.min(100, (selected.length / max) * 100);
          progressBar.style.width = pct + '%';
        }

        cards.forEach(function (card) {
          var btn = card.querySelector('.box-composer__select');
          var isSelected = card.classList.contains('is-selected');
          var isMaxed = !isSelected && selected.length >= max;

          btn.textContent = isSelected ? 'Retirer' : 'Ajouter à ma box';
          btn.disabled = isMaxed;
          card.classList.toggle('is-maxed', isMaxed);
        });

        if (form) {
          // On désactive TOUS les boutons submit du formulaire (au cas où
          // il y en aurait plusieurs), pas juste le premier trouvé.
          form.querySelectorAll('[type="submit"]').forEach(function (btn) {
            btn.disabled = selected.length !== max;
          });

          form.querySelectorAll('input[name^="properties[Saveur"]').forEach(function (el) { el.remove(); });
          selected.forEach(function (card, i) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[Saveur ' + (i + 1) + ']';
            input.value = card.dataset.flavor;
            form.appendChild(input);
          });
        }

        if (errorMsg) errorMsg.textContent = '';
      }

      function toggleCard(card) {
        if (card.classList.contains('is-maxed')) return;
        card.classList.toggle('is-selected');
        updateState();
      }

      cards.forEach(function (card) {
        var btn = card.querySelector('.box-composer__select');
        var image = card.querySelector('.box-composer__image');

        btn.addEventListener('click', function () {
          toggleCard(card);
        });

        if (image) {
          image.addEventListener('click', function () {
            toggleCard(card);
          });
        }
      });

      // Verrou de sécurité : même si le bouton n'est pas (ou plus)
      // désactivé pour une raison quelconque, on bloque le submit réel
      // du formulaire tant que le compte n'est pas atteint.
      if (form && !form.dataset.boxComposerGuard) {
        form.dataset.boxComposerGuard = 'true';
        form.addEventListener(
          'submit',
          function (e) {
            var selected = selectedCards();
            if (selected.length !== max) {
              e.preventDefault();
              e.stopImmediatePropagation();
              if (errorMsg) {
                errorMsg.textContent = 'Choisis ' + max + ' saveurs avant d\'ajouter au panier.';
              }
            }
          },
          true
        );
      }

      updateState();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
